import './header';
import './footer';
import './newsletter';

new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#footer',
  methods: {
    cartPreview() {
      function updateCartPreview(data) {
        const items = data.cart_data.items;
        const resultItems = data.result;

        let cartPreview = document.querySelector('.cart-preview');
        if (cartPreview) {
          let itensCartPreview = document.querySelector('.cart_preview-items');
          itensCartPreview.innerHTML = '';

          items.forEach((item, index) => {
            let brandHtml = item.brand ? `<p class="cart-item-content-brand">${item.brand}</p>` : '';
            let formattedPrice = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.unit_price);
            let sizeSelect = '';
            if (item.options && item.options.length > 0) {
              sizeSelect = `
                <label class="cart-item-content-size">
                  Tamanho:
                  <div class="select-content">
                    <select class="variation-select" data-original-id="${item.original_id}">
                      ${item.options.map(opt => `
                        <option 
                          value="${opt.product_id}" 
                          ${opt.product_id == item.original_id ? 'selected' : ''} 
                          ${!opt.available ? 'disabled' : ''}>
                            ${opt.value}
                        </option>
                      `).join('')}
                    </select>
                  </div>
                </label>
              `;
            }

            // ID correto que a API quer pra deletar (do result)
            const deleteId = resultItems[index]?.id;

            let itemHTML = `
              <li class="cart-item ${item.is_gift ? 'is-gift' : ''}" data-product-id="${item.id}">
                <figure>
                  <img src="${item.image_medium}" alt="${item.name}">
                </figure>
                <div class="cart-item-content">
                  <h4 class="cart-item-content-name">${item.name}</h4>
                  <p class="cart-item-content-price">${formattedPrice}</p>
                  <div class="group-content"> 
                    ${sizeSelect}
                    <div class="group-quantity">
                      <button class="btn-decrease" data-product="${item.original_id}" data-qtd="${item.quantity}">-</button>
                      <span class="qtd-value">${item.quantity}</span>
                      <button class="btn-increase" data-product="${item.original_id}" data-qtd="${item.quantity}">+</button>
                    </div>
                    <button class="delete-item-button" data-original-id="${deleteId}"></button>
                  </div>
                </div>
              </li>
            `;

            itensCartPreview.innerHTML += itemHTML;
          });

          document.querySelectorAll('.quant_itens_carrinho').forEach(el => {
            el.textContent = String(data.result.length).padStart(2, '0');
          });

          document.querySelector('.total_value_cart_preview').textContent =
            new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.cart_data.total);

          // Atualiza eventos dos botões
          document.querySelectorAll('.delete-item-button').forEach(button => {
            button.addEventListener('click', function () {
              let itemId = this.getAttribute('data-original-id');
              deleteCartItem(itemId);
            });
          });

          document.querySelectorAll('.btn-increase').forEach(button => {
            button.addEventListener('click', function () {
              const originalId = this.getAttribute('data-product');
              const qtdAtual = parseInt(this.getAttribute('data-qtd'), 10);
              
              updateItemQuantity(originalId, qtdAtual + 1);
            });
          });

          document.querySelectorAll('.btn-decrease').forEach(button => {
            button.addEventListener('click', function () {
              const originalId = this.getAttribute('data-product');
              const qtdAtual = parseInt(this.getAttribute('data-qtd'), 10);
              if (qtdAtual > 1) {
                updateItemQuantity(originalId, qtdAtual - 1);
              } else {
                deleteCartItem(originalId);
              }
            });
          });

          document.querySelectorAll('.variation-select').forEach(select => {
            select.addEventListener('change', function () {
              const selectedOption = this.options[this.selectedIndex];
              const newProductId = selectedOption.value;

              const cartItemEl = this.closest('.cart-item-content');
              const currentQty = parseInt(cartItemEl.querySelector('.qtd-value')?.textContent || 1, 10);
          
              const cartItem = this.closest('.cart-item');
              const itemId = cartItem.classList.contains('is-gift') ? cartItem?.querySelector('.delete-item-button')?.getAttribute('data-original-id') : cartItem?.getAttribute('data-product-id');
              const currentProductId = cartItem.querySelector('select')?.getAttribute('data-original-id');
          
              if (!itemId || !currentProductId || !newProductId) {
                console.error('IDs insuficientes para processar troca de variação.');
                return;
              }
          
              const payload = [{
                addon_values: "[]",
                as_free: false,
                is_buying_by_measure: false,
                item_id: itemId,
                product: currentProductId,
                new_product: newProductId,
                quantity: currentQty,
                replace_quantity: true
              }];
          
              console.log('Payload enviado para o carrinho:', payload);
          
              $.ajax({
                type: 'POST',
                url: '/api/front/cart/items/?version=2',
                headers: { 'Content-Type': 'application/json' },
                dataType: 'json',
                data: JSON.stringify(payload)
              }).done(function (data) {
                if (data && data.cart_data && data.result) {
                  updateCartPreview(data);
                  select.setAttribute('data-original-id', newProductId);
                }
              }).fail(function (jqXHR, textStatus, errorThrown) {
                console.error('Erro ao trocar variação:', errorThrown);
                alert('Erro ao trocar o tamanho do produto.');
              });
            });
          });
        }
      }

      function deleteCartItem(id) {
        $.ajax({
          type: 'DELETE',
          url: '/api/front/cart/items/remove',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json',
          data: JSON.stringify([{ id: id }])
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            reloadCartPreview();
            updateCartPreview(data);
          }
        }).fail(function (err) {
          console.error('Erro ao remover item do carrinho:', err);
        });
      }

      function updateItemQuantity(originalId, newQty) {
        const payload = [{
          addon_values: "[]",
          as_free: false,
          is_buying_by_measure: false,
          product: originalId,
          quantity: newQty,
          replace_quantity: true,
        }];

        console.log('Payload enviado para o carrinho:', payload);

        $.ajax({
          type: 'POST',
          url: '/api/front/cart/items/?version=2',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json',
          data: JSON.stringify(payload)
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            updateCartPreview(data);
          }
        }).fail(function (jqXHR, textStatus, errorThrown) {
          var data = jqXHR.responseJSON;
  
          if (Array.isArray(data) && data.length > 0 && data[0].stock) {
            alert(`O produto <b>"${data[0].stock.product.name}"</b> possui <b>${data[0].stock.quantity}</b> unidade[s] em estoque.`);
          } else {
            alert('Ocorreu um erro inesperado ao atualizar a quantidade.');
          }
        
          console.error('Erro ao atualizar quantidade:', errorThrown);
        });
      }

      function reloadCartPreview() {
        $.ajax({
          type: 'GET',
          url: '/api/front/cart/items/?version=2',
          headers: { 'Content-Type': 'application/json' },
          dataType: 'json'
        }).done(function (data) {
          if (data && data.cart_data && data.result) {
            updateCartPreview(data);

            document.querySelectorAll('.quant_itens_carrinho').forEach(el => {
              el.textContent = String(data.result.length).padStart(2, '0');
            });

            document.querySelector('.total_value_cart_preview').textContent =
              new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(data.cart_data.total);
          }
        });
      }

      $.ajax({
        type: 'GET',
        url: '/api/front/cart/items/?version=2',
        headers: { 'Content-Type': 'application/json' },
        dataType: 'json'
      }).done(function (data) {
        if (data && data.cart_data && data.result) {
          updateCartPreview(data);
        }
      });

      $(document).on("ajaxComplete", function (event, xhr, settings) {
        try {
          if (
            settings.url.includes('/api/front/cart/items/?version=2') &&
            settings.type === 'POST' &&
            xhr.responseJSON &&
            Array.isArray(xhr.responseJSON.result)
          ) {
            reloadCartPreview();
          }
        } catch (e) {
          console.warn('Erro ao interpretar payload do AJAX:', e);
        }
      });
    },
  },
  mounted() {
    // this.cartPreview();
  }
});

/* Fix bug with slick on new product render (vitrine) */
const elementosLazy = document.querySelectorAll('.lazy-img');

elementosLazy.forEach(elemento => {
  const dataSrc = elemento.getAttribute('data-src');
  if (dataSrc) {
    elemento.setAttribute('src', dataSrc);
    elemento.removeAttribute('data-src');
  }
});

// Cart has a delay and this code here fix it
setTimeout(() => {
  if (document.body.id === 'cart') {
    const elementosLazy = document.querySelectorAll('.lazy-img');

    elementosLazy.forEach(elemento => {
      const dataSrc = elemento.getAttribute('data-src');
      if (dataSrc) {
        elemento.setAttribute('src', dataSrc);
        elemento.removeAttribute('data-src');
      }
    });
  }
}, 5000);

/* Header Padding fix */
var page404Element = document.querySelector('.page-404');

if (page404Element) {
  page404Element.style.paddingTop = '133px';
  page404Element.style.setProperty('padding-top', '133px', 'important');
}

/* Name hover translate effect */
const figcaptionElements = document.querySelectorAll('.product-item__content--figcaption-name');

figcaptionElements.forEach((figcaption) => {
  const anchor = figcaption.querySelector('a');
  if (anchor) {
    const figcaptionWidth = figcaption.offsetWidth;
    const anchorWidth = anchor.offsetWidth;

    const transitionDuration = Math.max(1, Math.abs(anchorWidth - figcaptionWidth) / 100);

    if (anchorWidth > figcaptionWidth) {
      anchor.style.transition = `all ${transitionDuration}s linear`;
      figcaption.classList.add('action');
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {

  const overlay = document.querySelector('.header__product-item--options-overlay');
  const options = document.querySelector('.header__product-item--options');
  
  // Função para adicionar os eventos de clique aos botões de compra
  function addBuyButtonEvent() {
    const allProducts = document.querySelectorAll('.product-item');
  
    allProducts.forEach(element => {
      const button = element.querySelector('.buybox');
      const optionsElement = element.querySelector('.product-item__options');
      
      if (button && optionsElement) {
        button.addEventListener('click', () => {
          options.innerHTML = ''; // Limpa opções anteriores
          options.append(optionsElement.cloneNode(true)); // Clonando o optionsElement para evitar conflito
          overlay.classList.add('active');
          options.classList.add('active'); // Chama a função para configurar eventos nas opções
        });
      }
    });
  }
  
  // Usando delegação de eventos no contêiner pai dos produtos
  document.body.addEventListener('click', (event) => {
    const button = event.target.closest('.buybox');
  
    if (button) {
      const element = button.closest('.product-item');
      const optionsElement = element.querySelector('.product-item__options');
  
      if (optionsElement) {
        options.innerHTML = ''; // Limpa opções anteriores
        options.append(optionsElement.cloneNode(true)); // Clonando o optionsElement
        overlay.classList.add('active');
        options.classList.add('active'); // Chama a função para configurar eventos nas opções
      }
    }
  });
  
  // Lógica para fechar o overlay ao clicar no overlay
  if (overlay) {
    overlay.addEventListener('click', () => {
      overlay.classList.remove('active');
      options.classList.remove('active');
      options.innerHTML = ''; // Limpa opções ao fechar
    });
  }
  
  // Chame a função uma vez para os produtos já existentes
  addBuyButtonEvent();



  function loadSvg() {
     const svgs = document.querySelectorAll("[class^='no-svg-']");

    svgs.forEach(function(svg) {
      var oldClasses = svg.getAttribute("class");
      var newClasses = oldClasses.replace(/no-svg-/g, '');
      svg.setAttribute("class", newClasses);
    });
  }

  function onFirstScroll() {
    loadSvg();
    window.removeEventListener('scroll', onFirstScroll);
  }

  window.addEventListener('scroll', onFirstScroll, {passive: true});

  var elements = document.querySelectorAll('.product-campaigns-tags__campaign');

  Array.from(elements).forEach(function (tag) {
    if (tag.textContent.includes("Black") || tag.textContent.includes("BLACK") || tag.textContent.includes("black")) {
      tag.classList.add("black");
    }
  });


  (function ($) {
    $.fn.visible = function (partial) {

      var $t = $(this),
        $w = $(window),
        viewTop = $w.scrollTop(),
        viewBottom = viewTop + $w.height(),
        _top = $t.offset().top,
        _bottom = _top + $t.height(),
        compareTop = partial === true ? _bottom : _top,
        compareBottom = partial === true ? _top : _bottom;

      return ((compareBottom <= viewBottom) && (compareTop >= viewTop));
    };

  })(jQuery);

  function loadWidgets(event) {

    $(".product-item:not(.widget-loaded)").each(function (i, el) {
      var el = $(el);
      if (el.visible(true)) {
        el.addClass("widget-loaded");
        $(el).children().trigger("mouseenter");
      } else {
        //el.removeClass("visible");
      }
    });
  }

  $(window).scroll(loadWidgets);
  setTimeout(loadWidgets, 0);

});